import agent from 'agent'
import { fetchQueryData } from 'hooks/use-gremlin-query'
import { type failureFlagsQueryKeys } from 'queries/failure-flags/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'
import { ms } from 'utils/time/millisecond'

import type { QueryFunctionContext } from 'react-query'
import type { FailureFlagsExperimentsActivePagedResponse } from 'types/api/failure-flags/experiments/active'

export const FAILURE_FLAGS_STALE_TIME = ms.seconds(30)
export const FAILURE_FLAGS_REFETCH_INTERVAL = ms.seconds(60)

// The endpoint technically returns a paginated list. The API for this endpoint is currently set up to return all results
// regardless of the page size, so we just extract the "items" value and return it.
// TODO: evaluate how to handle pagination if the API changes
export function transformFailureFlagsExperimentsActivePagedResponse(
  data: FailureFlagsExperimentsActivePagedResponse
) {
  if (!data) throw new Error('Unable to fetch running failure flag experiments')

  return data.items
}

export function fetchFailureFlagsExperimentsActive({
  queryKey: [endpoint, params]
}: QueryFunctionContext<
  ReturnType<typeof failureFlagsQueryKeys.getExperimentsActive>
>) {
  const endpointWithParams = getEndpointWithParams(endpoint, params)

  return fetchQueryData<FailureFlagsExperimentsActivePagedResponse>(
    endpointWithParams,
    {
      // When we pass an AxiosRequestConfig with a transformResponse function, it overrides Axios
      // defaults, which originally parses the response as JSON. Mixing this default back into the
      // transformation array avoids having to parse text as JSON in a blocking manner.
      transformResponse: [
        ...[agent.defaults.transformResponse ?? []],
        transformFailureFlagsExperimentsActivePagedResponse
      ].flat()
    }
  )
}
